import React from 'react';
import ClassAssembly12C2026 from 'views/ClassAssembly12C2026';

const ClassAssemblyPage = () => {
  return <ClassAssembly12C2026 />;
};

export default ClassAssemblyPage;
